module.exports = __webpack_public_path__ + "static/Ananas-da1deb078e099de07fbc89fc4f9260e0.png";